function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4430_202046)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4430_202046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93098 2.2268L0.516098 -28.0113L2.53146 -30.4863L4.75661 -26.3078L13.9943 -22.6023L27.469 -28.0113L20.0541 2.2268L27.9849 2.2268L13.9943 22.0692L0.000224112 2.2268L7.93098 2.2268Z",
    fill: "#0C7497",
    style: {
      fill: "#0C7497",
      fill: "color(display-p3 0.0471 0.4549 0.5922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94612 -0.248232L2.53123 -30.4863L16.006 -25.0773L29.4841 -30.4863L22.0692 -0.248233L30 -0.248234L16.006 19.5942L2.01536 -0.248231L9.94612 -0.248232Z",
    fill: "#00C0FF",
    style: {
      fill: "#00C0FF",
      fill: "color(display-p3 0.0000 0.7529 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000104688 2.22698L2.01526 -0.248046L16.0059 19.5944L13.9939 22.0694L-0.000104688 2.22698Z",
    fill: "#1497AD",
    style: {
      fill: "#1497AD",
      fill: "color(display-p3 0.0784 0.5922 0.6784)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4430_202046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: -31,
    width: 28,
    height: 51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94612 -0.248232L2.53123 -30.4863L16.006 -25.0773L29.4841 -30.4863L22.0692 -0.248233L30 -0.248234L16.006 19.5942L2.01536 -0.248231L9.94612 -0.248232Z",
    fill: "#00C0FF",
    style: {
      fill: "#00C0FF",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4430_202046)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94612 -0.246702L2.53124 -30.4848L16.006 -25.0758L29.687 -30.9297L22.0692 -0.246703L30 -0.246704L17.0205 20.4911L2.01536 -0.246701L9.94612 -0.246702Z",
    stroke: "url(#paint0_linear_4430_202046)",
    style: {},
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M-12.7354 -37.2988L16.0918 -37.2988L16.0918 26.3113L-12.7354 26.3113L-12.7354 -37.2988Z",
    fill: "url(#paint1_linear_4430_202046)"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4430_202046",
    x1: 30.282,
    y1: -5.2052,
    x2: 1.71271,
    y2: -5.2052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FCFCFC",
    style: {
      stopColor: "#FCFCFC",
      stopColor: "color(display-p3 0.9882 0.9882 0.9882)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F3F3F3",
    style: {
      stopColor: "#F3F3F3",
      stopColor: "color(display-p3 0.9529 0.9529 0.9529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3E3E3",
    style: {
      stopColor: "#E3E3E3",
      stopColor: "color(display-p3 0.8902 0.8902 0.8902)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CECECE",
    style: {
      stopColor: "#CECECE",
      stopColor: "color(display-p3 0.8078 0.8078 0.8078)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#B2B2B2",
    style: {
      stopColor: "#B2B2B2",
      stopColor: "color(display-p3 0.6980 0.6980 0.6980)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#909090",
    style: {
      stopColor: "#909090",
      stopColor: "color(display-p3 0.5647 0.5647 0.5647)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#676767",
    style: {
      stopColor: "#676767",
      stopColor: "color(display-p3 0.4039 0.4039 0.4039)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#373737",
    style: {
      stopColor: "#373737",
      stopColor: "color(display-p3 0.2157 0.2157 0.2157)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#030303",
    style: {
      stopColor: "#030303",
      stopColor: "color(display-p3 0.0118 0.0118 0.0118)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4430_202046",
    x1: 1.93956,
    y1: -2.94977,
    x2: 0.888207,
    y2: -18.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4430_202046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 22,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 30 0.0683594)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4430_202046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 22,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 30 0.0683594)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.adbb1813078a3aa895006cd792915924.svg";
export { ForwardRef as ReactComponent };